import { render, staticRenderFns } from "./step_about.vue?vue&type=template&id=2d986842&scoped=true"
import script from "./step_about.vue?vue&type=script&lang=js"
export * from "./step_about.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d986842",
  null
  
)

export default component.exports